import React, { Profiler, type ProfilerOnRenderCallback } from 'react';
import { _ } from '@splunk/ui-utils/i18n';
import {
    AbsoluteLayout,
    AbsoluteLayoutApi,
    GridLayout,
    GridLayoutApi,
} from '@splunk/dashboard-layouts';
import { console } from '@splunk/dashboard-utils';
import type { PresetMap } from '@splunk/dashboard-types';

import { withInitialShowGrid, withLayoutConfig } from './utils';

import datasourcePresets from './DatasourcePresets';
import eventHandlerPresets from './EventHandlerPresets';
import inputPresets from './InputPresets';
import vizPresets from './VisualizationPresets';

export const onRender: ProfilerOnRenderCallback = (
    id, // the "id" prop of the Profiler tree that has just committed
    phase, // either "mount" (if the tree just mounted) or "update" (if it re-rendered)
    actualDuration // time spent rendering the committed update
    // baseDuration, // estimated time to render the entire subtree without memoization
    // startTime, // when React began rendering this update
    // commitTime, // when React committed this update
    // interactions // the Set of interactions belonging to this update
) => {
    console.info(id, phase, actualDuration);
};

export const withProfiler =
    <P extends Record<string, any>>( // eslint-disable-line @typescript-eslint/no-explicit-any
        LayoutComponent: React.ComponentType<P>
    ) =>
    (props: P) => (
        <Profiler
            id={LayoutComponent.displayName || 'ProfiledLayout'}
            onRender={onRender}
        >
            <LayoutComponent {...props} />
        </Profiler>
    );

export default {
    layouts: {
        absolute: withLayoutConfig(
            withInitialShowGrid(withProfiler(AbsoluteLayout)),
            {
                description: _('pixel level control'),
                name: _('Absolute'),
                layoutApi: AbsoluteLayoutApi,
            }
        ),
        grid: withLayoutConfig(
            withInitialShowGrid(withProfiler(GridLayout), { value: false }),
            {
                description: _('quick organization'),
                name: _('Grid'),
                layoutApi: GridLayoutApi,
                scrollOnItemAdd: true,
            }
        ),
    },
    ...datasourcePresets,
    ...eventHandlerPresets,
    ...inputPresets,
    ...vizPresets,
} as PresetMap;
